import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 21h4","key":"svg-0"}],["path",{"d":"M10 21v-10","key":"svg-1"}],["path",{"d":"M10 6v-3","key":"svg-2"}],["path",{"d":"M6 6h10l2 2.5l-2 2.5h-10l0 -5","key":"svg-3"}]]

const IconSignRight = createReactComponent('outline', 'sign-right', 'SignRight', __iconNode);

export default IconSignRight;